import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';
import device from '../../config/device';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
 div {
    
    .button {
      background: var(--yellowDark);
      padding: 10px 25px;
      box-sizing: border - box;
      box-shadow: 2px 2px 0 rgba(12, 13, 14, 0.15);
      transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
      border-radius: 15px;

      &:hover {
        box-shadow: 1px 1px 0 rgba(12, 13, 14, 0.15);
        background: ${darken(0.04, '#f7c325')};
      }

      @media ${device.mobileMinTabMax} {
        padding: 0 15px;
        margin: 5px;
      }
    }
  }

  button {
    display: flex;
    align-items: center;
    color: var(--blueDark);
    transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
    font-size: 1.2rem;
    font-weight: bold;

    &:hover {
      color: ${darken(0.1, '#1c2156')};
    }

    @media ${device.mobileMinTabMax} {
      margin: 5px;
      font-size: 0.9rem;
    }
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 52px);
  background: var(--white);
  padding: 0 30px;
  overflow: auto;

  h1 {
    color: var(--blueDark);
  }

  > div {
    display: flex;
    justify-content: center;

    input {
      width: 80%;
      border: 2px solid var(--yellowDark);
      border-radius: 2px 0 0 2px;
      border-right: 0;
      height: 35px;
      padding: 0 15px;
      margin: 10px 0 50px 0;
      color: var(--black);

      &::placeholder {
        color: var(--gray);
      }
    }

    > svg {
      border: 2px solid var(--yellowDark);
      padding-right: 3px;
      border-radius: 0 2px 2px 0;
      border-left: 0;
      height: 35px;
      margin: 10px 0 50px 0;
      cursor: pointer;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(207, 207, 207, 0.7);
  border-radius: 10px;
  padding: 10px 20px;
  color: var(--greenDark);
  margin: 20px 10px;
  font-size: 1.1rem;

  span {
    padding: 2px 0;

    @media ${device.mobileMinTabMax} {
      font-size: 0.9rem;
    }
  }

  .status {
    display: flex;
    padding: 10px 0;
    color: ${props => (props.statusColor ? props.statusColor : '#20303d')};

    svg {
      color: var(--yellowDark);
    }

    @media ${device.mobileMinTabMax} {
      display: flex;
      width: max-content;
      font-size: 0.9rem;
    }
  }

  > div {
    display: flex;
    justify-content: space-around;
    flex-direction: row;

    .button {
      background: var(--yellowDark);
      padding: 10px 25px;
      box-sizing: border - box;
      box-shadow: 2px 2px 0 rgba(12, 13, 14, 0.15);
      transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
      border-radius: 15px;

      &:hover {
        box-shadow: 1px 1px 0 rgba(12, 13, 14, 0.15);
        background: ${darken(0.04, '#f7c325')};
      }

      @media ${device.mobileMinTabMax} {
        padding: 0 15px;
        margin: 5px;
      }
    }
  }

  button {
    display: flex;
    align-items: center;
    color: var(--blueDark);
    transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
    font-size: 1.2rem;
    font-weight: bold;

    &:hover {
      color: ${darken(0.1, '#1c2156')};
    }

    @media ${device.mobileMinTabMax} {
      margin: 5px;
      font-size: 0.9rem;
    }
  }
`;

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayDark);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;

  span {
    background-color: var(--gray);
    color: var(--white);
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.4s;
    font-size: 14px;
  }

  &:hover span {
    opacity: 1;
  }
`;
